import React, { ChangeEvent } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

import { ISupplier } from 'hooks/useSuppliers';

import { css } from './styles';
import { useFetch } from 'hooks/useFetch';

interface ISuppliersDropdownProps {
  handleChange?: (e: ChangeEvent<{}>, supplier: ISupplier | null) => void;
}

const shapeSuppliers = (suppliers: any[]): ISupplier[] => {
  return suppliers.map((supplier) => {
    return {
      id: supplier.ID_PESSOA,
      name: supplier.NM_PESSOA
    };
  });
};

export const SuppliersDropdown = ({ handleChange }: ISuppliersDropdownProps) => {
  const styles = css();

  const { data } = useFetch({ url: 'fornecedores' });
  const suppliers: ISupplier[] = data && shapeSuppliers(data.itens);

  return (
    <Autocomplete
      id="suppliersDropdown"
      options={suppliers || []}
      onChange={handleChange || undefined}
      getOptionLabel={(supplier) => `${supplier.id} - ${supplier.name}`}
      style={{ width: '450px' }}
      renderInput={(params) => (
        <TextField
          {...params}
          className={styles.input}
          variant="outlined"
          label="Selecione um fornecedor"
          InputLabelProps={{ className: styles.label }}
        />
      )}
    />
  );
};
